module.exports = __webpack_public_path__ + "img/SGD.fe56350b.png";